/* global templateOverride */
(function() {
    templateOverride([{
        state: 'eventix.dashboard',
        where: 'body',
        what: function() {
            require('./Ticketscan.less');
        },
        how: 'ignore'
    }]);
})();
/**
 * Example overrides
 *
 * Add an element to the breadcrumbs list, trigger once on the root dashboard state
 * ```
 * {
 *    state: 'eventix.dashboard',
 *    where: 'ol.breadcrumb',
 *    what: '<li>{{ vm.company.name }}</li>'
 *    how: 'prepend'
 * }
 * ```
 *
 * Add HTML to the page that is loaded from an external file
 * ```
 * {
 *    state: 'eventix.dashboard',
 *    where: 'table-view',
 *    what: require('./whitelabel-page.html'),
 *    how: 'after'
 * }
 * ```
 *
 * Replace a button on a specific page
 * ```
 * {
 *    state: 'eventix.dashboard.trackers',
 *    where: '.btn[ng-click*="new()"]',
 *    what: function() {
 *        var expiredSince = require('moment')('2018-01-01').fromNow()
 *        return `<button class="btn btn-info" disabled>Deprecated since ${expiredSince}</button>`;
 *    }
 *    how: 'replace'
 * }
 * ```
 *
 * Inject a stylesheet into dashboard
 * ```
 * {
 *    state: 'eventix.dashboard',
 *    where: 'body',
 *    what: function() {
 *        require('./whitelabel.less');
 *    },
 *    how: 'ignore'
 * }
 * ```
 *
 * Make an ajax call
 * ```
 * {
 *      state: 'eventix.dashboard',
 *      where: 'ol.breadcrumb',
 *      what: /*@ngInject*\/ function($http) {
 *          return $http.get('https://httpbin.org/ip').then(response => `<li>${response.data.origin}</li>`);
 *      },
 *      how: 'prepend'
 * }
 * ```
 *
 * Inject a modal on a specific shop. (Don't forget the ngInject comment that'll ensure proper minification)
 * ```
 * {
 *    state: {
 *        name: 'eventix.shop.tickets',
 *        params: { shopId: '00000000-0000-0000-0000-000000000000' }
 *    }
 *    where: 'body',
 *    what: /* @ngInject *\/ function($uibModal, store) {
 *        let returningVisitor = store.get('HasSeenModal')
 *        if(returningVisitor)
 *            return;
 *        store.set('HasSeenModal', 1);
 *        $uibModal.open({ template: 'Your modal here' });
 *    },
 *    how: 'ignore'
 * }
 * ```
 *
 *  Complex example, using Models, and using scope in a HTML template
 * ```
 * {
 *     state: 'eventix.dashboard.scanners',
 *       where: 'table-view',
 *       what: /*@ngInject*\/ function($uibModal, store , Event, $scope) {
 *           let guiModes = _.map(Event.cached, 'gui_mode');
 *           let hasNew = _.indexOf(guiModes, 'simple');
 *           $scope.hasNew = hasNew > -1;
*
 *           if(store.get('HasSeenScannerModal'))
 *               return scannerAppWarning;
 *           $uibModal.open({ template: modal , scope: $scope });
 *           store.set('HasSeenScannerModal', 1);
 *           return scannerAppWarning;
 *       }
 *       how: 'before',
 * }
 * ```
 */
